module.exports = __webpack_public_path__ + "fonts/araboto-black-webfont.eb3b9417.eot";